import styled from 'styled-components'

export const Label = styled.label`
  color: ${(props) => props.theme.labelTextColour};
  font-size: ${(props) => props.theme.labelFontSize};
  text-align: left;
  display: block;
  font-weight: ${(props) => props.bold && 'bold'};
`
